// Beds Beds Beds — theme interactivity: cart drawer, mobile nav, quantity steppers

document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var cartToggles = document.querySelectorAll('[data-cart-toggle]');
  var closeBtns = document.querySelectorAll('[data-cart-close]');
  var mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    refreshCartDrawer();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
  }

  cartToggles.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });
  closeBtns.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeDrawer();
    });
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Render cart drawer contents from /cart.js
  function refreshCartDrawer() {
    var body = document.querySelector('[data-cart-drawer-body]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    if (!body) return;
    body.innerHTML = '<p class="cart-drawer-loading">Loading cart…</p>';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
        if (cart.item_count === 0) {
          body.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.</p>';
          return;
        }
        var html = '<ul class="cart-drawer-list">';
        cart.items.forEach(function (item) {
          html += '' +
            '<li class="cart-drawer-item">' +
              '<img src="' + (item.image || '') + '" alt="" width="72" height="72">' +
              '<div class="cart-drawer-item-info">' +
                '<div class="cart-drawer-item-title">' + item.product_title + '</div>' +
                '<div class="cart-drawer-item-variant">' + (item.variant_title || '') + '</div>' +
                '<div class="cart-drawer-item-qty" data-line-item="' + item.key + '">' +
                  '<button type="button" data-qty-decrease>−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-qty-increase>+</button>' +
                '</div>' +
              '</div>' +
              '<div class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</div>' +
            '</li>';
        });
        html += '</ul>';
        html += '<div class="cart-drawer-subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>';
        html += '<a class="cart-drawer-checkout" href="/checkout">Checkout</a>';
        body.innerHTML = html;

        body.querySelectorAll('[data-qty-increase], [data-qty-decrease]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var wrap = btn.closest('[data-line-item]');
            var key = wrap.getAttribute('data-line-item');
            var span = wrap.querySelector('span');
            var qty = parseInt(span.textContent, 10);
            qty += btn.hasAttribute('data-qty-increase') ? 1 : -1;
            if (qty < 0) qty = 0;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: qty })
            }).then(function () { refreshCartDrawer(); });
          });
        });
      });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Intercept product-form submissions across the theme (product page + quick-add)
  document.body.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var formData = new FormData(form);
    if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Added ✓'; setTimeout(function () { submitBtn.textContent = submitBtn.dataset.originalText; }, 1500); }
        openDrawer();
      })
      .catch(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
      });
  });

  // Product page: swipeable main-image carousel, synced with the thumbnail row and arrows
  var mainCarousel = document.querySelector('[data-main-carousel]');
  var carouselSlides = mainCarousel ? Array.prototype.slice.call(mainCarousel.querySelectorAll('[data-main-carousel-slide]')) : [];
  function scrollToSlide(index, behavior) {
    var slide = carouselSlides[index];
    if (slide) slide.scrollIntoView({ behavior: behavior || 'smooth', inline: 'center', block: 'nearest' });
  }
  document.querySelectorAll('[data-thumb-index]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      scrollToSlide(parseInt(btn.getAttribute('data-thumb-index'), 10));
    });
  });
  var prevArrow = document.querySelector('[data-main-carousel-prev]');
  var nextArrow = document.querySelector('[data-main-carousel-next]');
  function currentSlideIndex() {
    if (!mainCarousel) return 0;
    var center = mainCarousel.scrollLeft + mainCarousel.clientWidth / 2;
    var closest = 0;
    var closestDist = Infinity;
    carouselSlides.forEach(function (slide, i) {
      var mid = slide.offsetLeft + slide.offsetWidth / 2;
      var dist = Math.abs(mid - center);
      if (dist < closestDist) { closestDist = dist; closest = i; }
    });
    return closest;
  }
  if (prevArrow) prevArrow.addEventListener('click', function () { scrollToSlide(Math.max(0, currentSlideIndex() - 1)); });
  if (nextArrow) nextArrow.addEventListener('click', function () { scrollToSlide(Math.min(carouselSlides.length - 1, currentSlideIndex() + 1)); });

  // Product page: resolve option selects to a real variant id, update price/image/availability
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var jsonEl = document.querySelector('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var selects = productForm.querySelectorAll('select[data-option-index]');
    var variantInput = productForm.querySelector('[data-variant-id]');
    var priceNow = document.querySelector('.bbb-product-price .bbb-now');
    var priceWas = document.querySelector('.bbb-product-price .bbb-was');
    var addBtn = productForm.querySelector('.bbb-add-to-cart');

    function currentSelections() {
      var vals = [];
      selects.forEach(function (s) { vals.push(s.value); });
      return vals;
    }
    function findVariant() {
      if (!product) return null;
      var sel = currentSelections();
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return sel[i] === undefined || sel[i] === opt; });
      });
    }
    function updateForVariant(variant) {
      if (!variant) return;
      variantInput.value = variant.id;
      if (priceNow) priceNow.textContent = '$' + (variant.price / 100).toFixed(2);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.style.display = '';
          priceWas.textContent = '$' + (variant.compare_at_price / 100).toFixed(2);
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (variant.featured_image && variant.featured_image.src) {
        var target = variant.featured_image.src.split('?')[0].split('/').pop();
        var matchIndex = carouselSlides.findIndex(function (slide) {
          var img = slide.querySelector('img');
          return img && img.src.split('?')[0].split('/').pop() === target;
        });
        if (matchIndex > -1) scrollToSlide(matchIndex, 'auto');
      }
    }
    selects.forEach(function (s) {
      s.addEventListener('change', function () { updateForVariant(findVariant()); });
    });
  }

  // initial cart count on load
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
  });
});